import styled from "styled-components";

import { portalColors } from "src/components";

export const CategoryRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

export const CategoryButton = styled.button`
    min-height: 2rem;
    padding: 0.25rem 0.7rem 0.25rem 0.35rem;
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    border: 1px solid ${p => p.$active ? p.$color : portalColors.borderStrong};
    border-radius: 999px;
    background: ${p => p.$active ? p.$softColor : portalColors.surface};
    color: ${portalColors.text};
    font: inherit;
    font-size: 0.78rem;
    font-weight: 800;
    cursor: pointer;
    transition: border-color 0.14s ease, background 0.14s ease, transform 0.14s ease;

    &:hover {
        border-color: ${p => p.$color};
        background: ${p => p.$softColor};
        transform: translateY(-1px);
    }

    &:focus-visible {
        outline: 3px solid ${p => p.$softColor};
        outline-offset: 2px;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;

        &:hover {
            transform: none;
        }
    }
`;

export const CategoryIconWrapper = styled.span`
    width: 1.45rem;
    height: 1.45rem;
    display: inline-grid;
    place-items: center;
    border-radius: 50%;
    background: ${p => p.$color};

    img {
        width: 0.88rem;
        height: 0.88rem;
        display: block;
    }
`;

export const LocationFieldWrap = styled.div`
    position: relative;
    display: flex;
    width: 100%;
`;

export const LocationButton = styled.div`
    width: 100%;
    min-height: 2rem;
    padding: 0.55rem 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    border: 1px solid ${portalColors.borderStrong};
    border-radius: 8px;
    background: ${portalColors.surface};
    color: ${portalColors.text};
    box-shadow: ${portalColors.inputShadow};
    font: inherit;
    text-align: left;
    cursor: pointer;

    &:hover {
        border-color: ${portalColors.blue};
    }
`;

export const LocationInput = styled.input`
    min-width: 0;
    flex: 1 1 auto;
    border: 0;
    outline: 0;
    background: transparent;
    color: ${portalColors.text};
    font: inherit;
    font-size: 0.9rem;
    font-weight: 800;

    &::placeholder {
        color: ${portalColors.textSoft};
        opacity: 1;
    }
`;

export const SelectedLocationSummary = styled.span`
    min-width: 0;
    flex: 1 1 auto;
    display: grid;
    gap: 0.12rem;
`;

export const LocationActionIcon = styled.span`
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;
    display: inline-grid;
    place-items: center;
    border-radius: 50%;
    background: ${portalColors.blueSoft};

    img {
        width: 1rem;
        height: 1rem;
        display: block;
    }
`;

export const ScreenReaderText = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;

export const LocationText = styled.span`
    min-width: 0;
    display: grid;
    gap: 0.12rem;
`;

export const LocationName = styled.span`
    color: ${portalColors.text};
    font-size: 0.9rem;
    font-weight: 800;
    overflow-wrap: anywhere;
`;

export const LocationAddress = styled.span`
    color: ${portalColors.mutedText};
    font-size: 0.76rem;
    font-weight: 550;
    overflow-wrap: anywhere;
`;

export const ResultsDropdown = styled.div`
    position: absolute;
    z-index: 20;
    top: calc(100% + 0.35rem);
    left: 0;
    right: 0;
    max-height: 18rem;
    overflow-y: auto;
    padding: 0.55rem;
    display: grid;
    gap: 0.45rem;
    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    background: ${portalColors.surface};
    box-shadow: ${portalColors.inputShadow};
`;

export const ResultsList = styled.div`
    display: grid;
    gap: 0.45rem;
`;

export const ResultButton = styled.button`
    width: 100%;
    padding: 0.7rem;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 0.65rem;
    align-items: center;
    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    background: ${portalColors.surface};
    color: ${portalColors.text};
    font: inherit;
    text-align: left;
    cursor: pointer;

    &:hover,
    &:focus-visible {
        border-color: ${p => p.$color};
        outline: none;
        background: ${p => p.$softColor};
    }
`;

export const BadgeRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
    align-items: center;
`;

export const BadgeButton = styled.button`
    min-height: 1.85rem;
    min-width: 0;
    max-width: 100%;
    height: 2rem;
    padding: 0 0.7rem;
    box-sizing: border-box;
    padding: 0.25rem 0.7rem;
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    border-radius: 999px;
    border: 1px solid ${p => p.$color};
    background: ${p => p.$softColor || portalColors.surface};
    color: ${p => p.$textColor || portalColors.text};
    font: inherit;
    font-size: 0.76rem;
    font-weight: 850;
    cursor: ${p => p.as === "button" ? "pointer" : "default"};

    span:last-child {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &:is(button):hover {
        background: ${portalColors.blueSoft};
    }

    &:is(button):focus-visible {
        outline: 3px solid ${portalColors.blueSoft};
        outline-offset: 2px;
    }
`;
